import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { superAdminApi } from '../lib/api';
import { Button } from '../components/ui/button';
import { Input } from '../components/ui/input';
import { Label } from '../components/ui/label';
import { Card, CardContent } from '../components/ui/card';
import { Shield, Loader2, AlertCircle } from 'lucide-react';

export default function SuperAdminLoginPage() {
  const navigate = useNavigate();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');
    try {
      const res = await superAdminApi.login({ email, password });
      localStorage.setItem('token', res.data.access_token);
      localStorage.setItem('user', JSON.stringify(res.data.user));
      navigate('/super-admin');
    } catch (err) {
      setError(err.response?.data?.detail || 'Identifiants incorrects');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-stone-950 flex items-center justify-center px-6">
      <div className="w-full max-w-sm">
        <div className="text-center mb-8">
          <div className="w-12 h-12 rounded-xl bg-emerald-700 flex items-center justify-center mx-auto mb-3">
            <Shield className="w-6 h-6 text-white" />
          </div>
          <h1 className="text-xl font-bold text-white">Super Administration</h1>
          <p className="text-sm text-stone-400 mt-1">Plateforme Daaraj SaaS</p>
        </div>

        <Card className="bg-stone-900 border-stone-800">
          <CardContent className="p-6">
            {error && (
              <div className="flex items-center gap-2 p-3 bg-red-950 text-red-400 text-sm rounded-lg mb-4" data-testid="sa-login-error">
                <AlertCircle className="w-4 h-4 shrink-0" />
                {error}
              </div>
            )}
            <form onSubmit={handleSubmit} className="space-y-4">
              <div>
                <Label className="text-stone-300">Email</Label>
                <Input
                  type="email" value={email} onChange={(e) => setEmail(e.target.value)}
                  className="bg-stone-800 border-stone-700 text-white" required data-testid="sa-email-input"
                />
              </div>
              <div>
                <Label className="text-stone-300">Mot de passe</Label>
                <Input
                  type="password" value={password} onChange={(e) => setPassword(e.target.value)}
                  className="bg-stone-800 border-stone-700 text-white" required data-testid="sa-password-input"
                />
              </div>
              <Button type="submit" disabled={loading} className="w-full bg-emerald-700 hover:bg-emerald-800" data-testid="sa-login-btn">
                {loading ? <Loader2 className="w-4 h-4 animate-spin" /> : 'Connexion'}
              </Button>
            </form>
          </CardContent>
        </Card>

        <div className="text-center mt-6">
          <button onClick={() => navigate('/')} className="text-sm text-stone-600 hover:text-stone-400" data-testid="sa-back-btn">
            Retour au site
          </button>
        </div>
      </div>
    </div>
  );
}
